
const API_ROOTT = 'http://localhost:3019';
const API_ROOT = 'https://app-node.talkcmo.com:3019';


// const webPath = 'https://talkcmo.ondotmail.com'
const webPath = 'https://talkcmo.com'


export { API_ROOT , webPath,API_ROOTT};